import React from 'react'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import WAIcon from 'react-icons/lib/fa/whatsapp'
import CloseIcon from 'react-icons/lib/fa/close'
import HomeIcon from 'react-icons/lib/md/home'

const Comprar = ({ data }) => (
  <div className="comprar-layout">        
    <h1>¿Cómo comprar?</h1>
    <p>Se tramita el pago mediante un depósito a la cuenta de <br /> 
    <b>Fiorella Pattoni Urbina</b> en dólares.</p> 
    <img className="bac-icon" src="https://www.baccredomatic.com/sites/all/themes/custom/foundation_bac/images/bacredomatic_logo.png" />
    <ul>
      <li><b>Cuenta BAC:</b> 922432570 </li>
      <li><b>SINPE:</b> 10200009224325704</li>
      <li><b>Cédula:</b> 1-1151-0626</li>
    </ul>
   <ul className="detalles">
		 <li>* Especificar en detalle el nombre de la pieza que se quiere adquirir.</li>
		 <li>* Enviar comprobante o pantallazo a <a href="mailto:info@fiorellapattoni.com">info@fiorellapattoni.com</a></li>
		 <li>* Enviar su ubicación al Whatsapp junto con una dirección <br />de correo electrónico 
		  para confirmar los detalles del envío.</li>
		</ul>  
    <p>Se ofrece la opción de pagar con datáfono junto con servicio de 
    mensajeria.<br />
    Coordinar detalles al email <a href="mailto:info@fiorellapattoni.com">info@fiorellapattoni.com</a> o por Whatsapp. 
    </p>
    <div class="nav-content">
      <ul className="tabs">        
        <li className="tab"><a href="whatsapp://send?abid=+50683075982"><WAIcon /> Whatsapp: 8307-5983</a></li>
        <li className="tab" ><Link to="/"><HomeIcon /> Inicio</Link></li>
        <li className="tab" ><Link to="acerca-de">Acerce de mi</Link></li>
      </ul>
    </div>
  </div>
)

export default Comprar





// WEBPACK FOOTER //
// ./src/pages/comprar.js